import { render, staticRenderFns } from "./OrderDashboard.vue?vue&type=template&id=3a5c7ef4"
import script from "./OrderDashboard.vue?vue&type=script&lang=js"
export * from "./OrderDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports